import Vue from 'vue';
import folderItem from './_folder.vue';
import defaultItem from './_item.vue';
import { declOfNum } from '@/utils/numbers';
export default Vue.extend({
    name: 'leveragesItemDefault',
    props: {
        item: {
            type: Object,
            required: true
        },
        searchField: {
            type: String,
            required: true
        },
        folderMenuInstanceID: {
            required: true
        },
        dragProccess: {
            type: Boolean,
            required: true
        },
        folderIDToRename: {
            required: true
        },
        isMultiSelect: {
            type: Boolean,
            required: true
        },
        automaticLeverage: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        declOfNum
    },
    components: {
        folderItem,
        defaultItem
    }
});
